import { registerBrick } from 'olympe';
import {ReactBrick, useProperty, ifNotTransparent, ifNotNull, cssToSxProps} from "@olympeio/core";
import {combineLatest} from "rxjs";
import React, {useState, useEffect} from "react";
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import Box from '@mui/material/Box';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';


export default class PDFReader extends ReactBrick {


    /**
     * @override
     */
    setupExecution($) {
        pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

        return combineLatest([
            $.observe('Hidden', false),
        ]);
    }

    /**
     * @override
     */
    updateParent(parent, element) {
        parent.style.overflow = 'visible'; // Allow overflow
        return super.updateParent(parent, element);
    }

    /**
     * @override
     */
    static getReactComponent($) {

        return (props) => {
            const [hidden] = props.values;
            const pdfFile = useProperty($, 'pdf file', true);
            const pageNumber = useProperty($, 'page displayed', true);
            const [file, setFile] = useState();

            useEffect(async () => {
                if (pdfFile) {
                    const data = await pdfFile.getContentAsBinary();
                    setFile(data);
                }
            }, [pdfFile]);

            const onDocumentLoadSuccess = async ({numPages}) => {
                $.set('pages', numPages);
            }

            const onPageLoadSuccess = async (page) => {
                let ratio = page.originalHeight / page.originalWidth;
                if (page.rotate === 270 || page.rotate === 90) {
                    ratio = page.originalWidth / page.originalHeight;
                }
                $.set('Height', $.get('Width') * ratio);
            }

            const onRef = (ref) => {
                $.set('canvas ref', ref);
            }

            return !hidden && (
                <Box
                    // Properties + UI
                    component={'div'}
                    sx={{
                        width: 1,
                        height: 1,
                        ...ifNotTransparent('borderColor', useProperty($, 'Border Color', true)),
                        ...ifNotNull('borderRadius', `${useProperty($, 'Border Radius', true)}px`, useProperty($, 'Border Radius', true)),
                        borderWidth: useProperty($, 'Border Width', true),
                        borderStyle: 'solid',
                        boxSizing: 'border-box',
                        ...ifNotTransparent('backgroundColor', useProperty($, 'Default Color', true)),
                        ...cssToSxProps(useProperty($, 'CSS Property', true))
                    }}

                    // Events
                    onClick={() => $.trigger('On Click')}
                >
                    <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} width={useProperty($,'Width', true)} onLoadSuccess={onPageLoadSuccess} canvasRef={onRef}/>
                    </Document>
                </Box>
            );
        }
    }
}

registerBrick('0192c7163ee543d2a42c', PDFReader);
